import { Component, ChangeDetectorRef, Input, OnInit, inject, output, input } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { jkRestReturn } from '../../services/jkInterface';
import { Observable } from 'rxjs';
import { jkRestReturnClass } from '../../services/jkClass';
import { FileUploadMode, UploadHttpMethod } from '../jkupload/jkupload.component';
import { JktextComponent } from '../jktext/jktext.component';


export function initConfig(
  form: any,
  disableClose: boolean = true,
  height: string = '95%',
  width: string = '95%',
  dialogClass: string = 'mat-dialog-container', //   custDialogClass: string ='custom-dialog-container' // 自定义样式类
): MatDialogConfig {
  let dialRet: jkRestReturn = new jkRestReturnClass();
  dialRet.obj = form;
  let dialConf: MatDialogConfig = {
    data: dialRet,
    hasBackdrop: true,
    //maxHeight: '90vh',
    //maxWidth: '90vw',
    maxWidth: '100vw',
    height: height,
    width: width,
    disableClose: disableClose,
    panelClass: dialogClass, // 預設就會顯示不出來!
  };
  return dialConf;
}

export function kmAttach(dialog: MatDialog, dbname: string, uploadHost: string, basePath: string, date: string, billType: string, billNo: string): Observable<any> {
  let uploadDirectory = `${basePath}/${dbname}/${date.substring(0, 6)}/${billType}-${billNo}`;
  let data = {
    uploadHost: uploadHost, // 上傳伺服器
    uploadDirectory: uploadDirectory, // 當前目錄
    uploadBaseUrl: '/upload',
    pathDisabled: true, // 是否禁用路徑選擇
    showNewFolderDialog: false, // 是否顯示新增資料夾按鈕
  };
  return dialog.open(UploadFileComponent, initConfig(data))
    .afterClosed();

}


interface FileItem {
  name: string;
  type: 'file' | 'folder';
  size: number;
  path: string;
  modified: string;
}

@Component({
  selector: 'app-upload-file',
  imports: [FormsModule, JktextComponent],
  templateUrl: './upload-file.component.html',
  styleUrl: './upload-file.component.css',
  standalone: true
})
export class UploadFileComponent extends JkBaseComponent implements OnInit {
  dialogRef = inject<MatDialogRef<UploadFileComponent>>(MatDialogRef);
  retParams = inject<jkRestReturn>(MAT_DIALOG_DATA);
  override http = inject(HttpClient);

  override comType: string = 'jkupload';
  _accept: string = '*';
  fileObj!: File;
  // 檔案瀏覽相關
  currentDirectory: string = '';
  fileList: FileItem[] = [];
  isLoading: boolean = false;
  selectedItems: FileItem[] = [];

  // 新增資料夾相關
  showNewFolderDialog: boolean = false;
  newFolderName: string = '';

  // 上傳檔案相關
  dragOver: boolean = false;

  readonly enabled = input(true);
  readonly value = input<File[]>([]); // 這裡不要再改了
  readonly valueChange = output<any>();
  onValueChange(newValue: any) {
    this.valueChange.emit(newValue);
  }

  uploadChange!: (e: any) => void;

  programId: string = 'upload';
  selectButtonText: string = '選擇檔案';
  labelText: string = '拖曳檔案到此處或點擊上方按鈕';
  //uploadUrl: string = '';
  allowedFileExtensions: string[] = [];
  minFileSize: number = 0;
  maxFileSize: number = 1000000;
  @Input() uploadFile: any = (e: any) => {
    if (this.uploadChange) {
      this.uploadChange(e);
    } else {
      this.fileUploader_uploadFile(e, null);
    }
  };
  multiple = false;
  uploadMode: FileUploadMode = 'useButtons'; // useButtons, useForm, instantly
  uploadMethod: UploadHttpMethod = 'POST';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  get accept(): string {
    return this._accept;
  };
  set accept(value: string) {
    this._accept = value;
    if (this.allowedFileExtensions.length > 0) {
      return;
    }
    if (value === '*') {
      this.allowedFileExtensions = [];
    }
    if (value === 'image/*') {
      this.allowedFileExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
    }
    if (value === 'video/*') {
      this.allowedFileExtensions = ['.mp4', '.avi', '.mov', '.mkv'];
    }
    if (value === 'audio/*') {
      this.allowedFileExtensions = ['.mp3', '.wav', '.ogg', 'm4a'];
    }
    if (value === 'application/*') {
      this.allowedFileExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt'];
    }
    if (value === 'application/pdf') {
      this.allowedFileExtensions = ['.pdf'];
    }
  };
  uploadBaseUrl: string = '/upload';
  uploadHost: string;
  constructor() {
    super();
    this.label.set('檔案上傳');
    this.uploadHost = this.retParams.obj.uploadHost; // 上傳伺服器
    this.currentDirectory = this.retParams.obj.uploadDirectory; // 當前目錄
    this.uploadBaseUrl = this.retParams.obj.uploadBaseUrl || '/upload'; // 上傳API路徑
    this.pathDisabled = this.retParams.obj.pathDisabled;  // 是否禁用路徑選擇
    this.showNewFolderDialog = this.retParams.obj.showNewFolderDialog; // 是否顯示新增資料夾按鈕
  }

  override ngOnInit() {
    super.ngOnInit();
    this.loadFileList();
  }
  pathDisabled: boolean = false;
  override async ngAfterViewInit() {
    super.ngAfterViewInit();

  }

  // 檔案瀏覽相關方法
  loadFileList() {
    this.isLoading = true;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // application/x-www-form-urlencoded
    let params = `?fromRoot=true&filePath=${this.currentDirectory}`;
    this.http.get<FileItem[]>(`${this.uploadHost}${this.uploadBaseUrl}/list` + params)
      //this.http.post<FileItem[]>(`${this.uploadHost}/list`, this.baseBody, { headers: headers })

      .subscribe({
        next: (data) => {
          this.fileList = data;
          this.isLoading = false;
          this.cdr.detectChanges();

        },
        error: (error) => {
          let msg = 'upload-file.loadFileList error:' + error.message;
          alert(msg);
          console.error('Error loading file list:', error);
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
  }

  navigateToFolder(folder: FileItem) {
    if (folder.type === 'folder') {
      this.currentDirectory = folder.path;
      this.loadFileList();
      this.selectedItems = [];
    }
  }

  navigateUp() {
    if (this.currentDirectory === '/') return;

    const parts = this.currentDirectory.split('/').filter(p => p);
    parts.pop();
    this.currentDirectory = parts.length ? '/' + parts.join('/') : '/';
    this.loadFileList();
    this.selectedItems = [];
  }

  // 檔案選擇相關方法
  toggleSelection(item: FileItem, event: MouseEvent) {
    event.stopPropagation();

    const index = this.selectedItems.findIndex(i => i.path === item.path);
    if (index === -1) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems.splice(index, 1);
    }
  }

  isSelected(item: FileItem): boolean {
    return this.selectedItems.some(i => i.path === item.path);
  }

  // 檔案上傳相關方法
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadFiles(input.files);
    }
  }

  uploadFiles(files: FileList) {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    };
    let params = `?fromRoot=true&filePath=${this.currentDirectory}`;

    const httpParams = new HttpParams({ fromString: params });
    this.http.post(`${this.uploadHost}${this.uploadBaseUrl}/upload`, formData, { params: httpParams })
      .subscribe({
        next: () => {
          this.loadFileList();
        },
        error: (error) => {
          console.error('Error uploading files:', error);
        }
      });
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;

    if (event.dataTransfer?.files) {
      this.uploadFiles(event.dataTransfer.files);
    }
  }

  // 資料夾操作相關方法
  createFolder() {
    if (!this.newFolderName.trim()) {
      alert('請輸入資料夾名稱');
      return;
    }

    const body = {
      folderName: this.newFolderName,
      directory: this.currentDirectory
    };
    let params = `?fromRoot=true&filePath=${this.currentDirectory}&folderName=${this.newFolderName}`;

    this.http.put(`${this.uploadHost}${this.uploadBaseUrl}/folder` + params, body)
      .subscribe({
        next: () => {
          this.newFolderName = '';
          this.showNewFolderDialog = false;
          this.cdr.detectChanges();
          this.loadFileList();
        },
        error: (error) => {
          alert('新增資料夾失敗: ' + error.message);
          console.error('Error creating folder:', error);
        }
      });
  }

  deleteSelectedItems() {
    if (this.selectedItems.length === 0) return;

    if (!confirm(`確定要刪除選中的 ${this.selectedItems.length} 個項目嗎？`)) {
      return;
    }

    const deletePromises = this.selectedItems.map(item => {
      let params = `?fromRoot=true&filePath=${item.path}`;
      if (item.type === 'file') {
        return this.http.delete(`${this.uploadHost}${this.uploadBaseUrl}/file` + params, {}).toPromise();
      } else {
        return this.http.delete(`${this.uploadHost}${this.uploadBaseUrl}/folder` + params, {}).toPromise();
      }
    });

    Promise.all(deletePromises)
      .then(() => {
        this.selectedItems = [];
        this.loadFileList();
      })
      .catch(error => {
        console.error('Error deleting items:', error);
        alert('刪除項目時發生錯誤: ' + error.message);
        // Still refresh the list even if there was an error
        this.selectedItems = [];
        this.loadFileList();
      });
  }

  // 原有方法保留
  getFileName(): string {
    let result = '';
    let n = this.value().length;
    if (n === 0) return '';
    for (let i = 0; i < n; i++) {
      if (i > 0) result += ',';
      result += this.value()[i].name;
    }
    return result;
  }

  async fileUploader_uploadFile(xfile: File, progressCallback: any) {
    if (!xfile) return;

    if (progressCallback)
      progressCallback(100);
    if (progressCallback)
      progressCallback(200);

    this.fileObj = xfile;
    if (this.fileObj) {
      if (this.fileObj.size > this.maxFileSize) {
        alert('檔案大小超過限制');
        return;
      }

      const formData = new FormData();
      formData.append('files', this.fileObj);
      let params = `?fromRoot=true&filePath=${this.currentDirectory}`;

      this.http.post(`${this.uploadHost}/upload` + params, formData)
        .subscribe({
          next: () => {
            this.loadFileList();
          },
          error: (error) => {
            console.error('Error uploading file:', error);
          }
        });
    }
  }

  // 格式化檔案大小
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // 格式化日期
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString();
  }
  doOk(e: any) {
    this.retParams.rowsAffected = this.fileList.length;
    this.dialogRef.close(this.retParams);
  }
  doCancel(e: any) {
    this.dialogRef.close(this.retParams);
  }
  downloadUrl: string = '';
  downloadFile(item: FileItem) {
    if (item.type !== 'file') {
      alert('只能下載檔案，不能下載資料夾');
      return;
    }
    this.downloadUrl = `${this.uploadHost}${this.uploadBaseUrl}/download?fromRoot=true&filePath=${item.path}`;
    let a = document.getElementById('downloadLink') as HTMLAnchorElement;
    if (a) {
      a.href = this.downloadUrl;
      a.download = item.name;
      a.click();
    }
    alert(item.name + '已下載');
  }
  downloadSelectedItems() {
    if (this.selectedItems.length === 0) {
      alert('請先選擇要下載的檔案');
      return;
    }

    const filePaths = this.selectedItems
      .filter(item => item.type === 'file')
      .map(item => item.path);

    if (filePaths.length === 0) {
      alert('所選項目中沒有檔案可供下載。');
      return;
    }

    // 假設後端 API 端點是 /batch-download
    // TODO: 後端未改 batch-download
    const batchDownloadUrl = `${this.uploadHost}${this.uploadBaseUrl}/batch-download`;

    // 使用 POST 請求將檔案路徑列表傳遞給後端
    this.http.post(batchDownloadUrl, { filePaths }, {
      responseType: 'blob', // 期待後端回傳一個檔案 Blob
      observe: 'response' // 獲取完整的 HTTP 回應，以便讀取檔名
    }).subscribe({
      next: (response) => {
        // 從 Content-Disposition 標頭獲取檔名
        const contentDisposition = response.headers.get('content-disposition');
        let filename = 'download.zip'; // 預設檔名
        if (contentDisposition) {
          const filenameRegex = /filename[^;=]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        // 建立一個 URL 來觸發下載
        const blob = new Blob([response.body!], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);

        // 建立一個隱藏的 a 標籤來觸發下載
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        // 下載後清除選擇
        this.selectedItems = [];
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Batch download error:', error);
        alert('下載多個檔案時發生錯誤: ' + error.message);
      }
    });
  }

}
